// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"0b9780c7","513":"2dc6dcb2","703":"1602734e","787":"8b21b353"}[chunkId] + ".chunk.js";
};